/* Design Studio "Previous Designs" — shared wiring for every studio surface
   (Justin 7-8). Loaded from snippets/v0-editor.liquid (defer), so it runs on:
     • the Design Studio pages — design-tool-widget renders the dedicated
       .studio-prev-overlay modal (snippets/studio-prev-designs.liquid)
     • product pages (Design From Scratch tab / overlay editor) — no dedicated
       modal there; the button opens the page's EXISTING previous-designs
       picker (.customTabelPopup__overlay-3, product-page-popups*.liquid) in
       "studio mode": window.__studioPickActive tells the PDP upload bridges
       to stand down, and the pick is inserted onto the fabric canvas here.
   Selection arrives via the md-picker:use-designs CustomEvent dispatched by
   my-designs-panel / ninja-design-library (picker mode). Insertion mirrors the
   studio Upload flow (fetch bytes → presign PUT → fabric.Image), so "Use
   Design" export works exactly as if the customer had uploaded the file.

   CORS: customer uploads re-fetch through ninjauploads-production.imgix.net
   (CORS *). Ready-To-Press originals live on s3.amazonaws.com/ninja-imgix
   (NO CORS) — those use the rtp-mirror/<basename> copy in the uploads bucket
   (one-time batch 2026-07-08; re-run for new designs), then direct S3 (in
   case a bucket CORS rule ever lands), then the Shopify product image. */
(function () {
  'use strict';
  if (window.__studioPrevDesignsBound) return;
  window.__studioPrevDesignsBound = true;

  var S3_UPLOADS = 'ninja-services-production-ninjauploadss3bucket-zks2mguobhe4.s3.amazonaws.com';
  var IMGIX_UPLOADS = 'ninjauploads-production.imgix.net';
  var CONVERT_EXT = /\.(ai|eps|pdf|svg|tiff?)$/i;

  function studioOverlay() { return document.querySelector('.studio-prev-overlay'); }
  function pdpOverlay() { return document.querySelector('.customTabelPopup__overlay-3'); }
  function isOpen(el) { return !!el && (el.getAttribute('style') || '').indexOf('display: none') === -1; }
  /* alv2 (Owen 2026-09-03): when the Artwork Library modal is on the page,
     the toolbar button opens IT instead of either legacy overlay. Same
     __studioPickActive contract, same md-picker:use-designs consumption below
     — alv2 dispatches the identical event with the identical items shape. */
  function alv2Available() {
    return !!(document.querySelector('[data-alv2-modal]') &&
              window.NTArtworkLibrary && window.NTArtworkLibrary.open);
  }

  /* ---- button wiring (retries briefly — pane revival order isn't guaranteed) ---- */
  function init() {
    var btn = document.getElementById('prev-designs-btn');
    if (!btn || btn.__spdInit) return;
    var so = studioOverlay(), po = pdpOverlay();
    if (!so && !po && !alv2Available()) { btn.style.display = 'none'; return; } /* nothing to open */
    btn.__spdInit = true;
    btn.style.display = '';

    btn.addEventListener('click', function () {
      if (alv2Available()) {
        /* The pick belongs on the canvas: every alv2 host's upload bridge
           (v4 designs.js, the PDP legacy bridge) stands down on this flag,
           and the md-picker handler below accepts the pick because of it. */
        window.__studioPickActive = true;
        window.NTArtworkLibrary.open();
        return;
      }
      var overlay = studioOverlay() || pdpOverlay();
      if (!overlay) return;
      var isStudioModal = overlay.classList.contains('studio-prev-overlay');
      /* PDP picker opened from the studio toolbar → the pick belongs on the
         canvas; product-page-popups' upload bridges check this flag. */
      window.__studioPickActive = !isStudioModal;
      /* 'block' beats the inline display:none; the :has() rule in
         my-designs-panel.liquid upgrades the overlay to grid. */
      overlay.style.display = 'block';
      /* if the modal was closed while the Ninja Design Library tab was
         active, the native panel may have re-rendered its grid since
         (fresh nodes, visible) — both would stack. Hand back to the
         first native tab; its click also fires the NDL exit handler. */
      var ndlWrap = overlay.querySelector('.ndl-wrap--picker');
      if (ndlWrap && ndlWrap.style.display === 'block') {
        var firstTab = overlay.querySelector('.md-tab[data-source]');
        if (firstTab) firstTab.click();
      }
    });

    /* studio modal only: backdrop click closes (the PDP overlay has its own
       close affordances) + Per Row control (the PDP modal has its own init). */
    if (so && !so.__spdWired) {
      so.__spdWired = true;
      so.addEventListener('click', function (e) {
        if (e.target === so) so.style.display = 'none';
      });
      initPerRow(so);
    }
  }
  function initPerRow(overlay) {
    var picker = overlay.querySelector('.customTabelPopup--md-picker');
    if (!picker || picker.__ctpInit) return;
    picker.__ctpInit = true;
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var initialCols = isMobile ? '2' : '4';
    picker.setAttribute('data-cols', initialCols);
    syncActive(initialCols);
    function relocateMobile() {
      var mobileCols = picker.querySelector('.ctp-cols--mobile');
      var filtersRow = picker.querySelector('.md-filters__row');
      if (mobileCols && filtersRow && !filtersRow.contains(mobileCols)) {
        filtersRow.appendChild(mobileCols);
        return true;
      }
      return false;
    }
    if (!relocateMobile()) {
      var mo = new MutationObserver(function () {
        if (relocateMobile()) mo.disconnect();
      });
      mo.observe(picker, { childList: true, subtree: true });
    }
    picker.addEventListener('click', function (e) {
      var b = e.target.closest('.ctp-cols-btn');
      if (!b) return;
      var cols = b.getAttribute('data-ctp-cols');
      if (!cols) return;
      picker.setAttribute('data-cols', cols);
      syncActive(cols);
    });
    function syncActive(cols) {
      picker.querySelectorAll('.ctp-cols-btn').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-ctp-cols') === cols);
      });
    }
  }
  var initTries = 0;
  (function initTick() {
    init();
    var btn = document.getElementById('prev-designs-btn');
    if ((!btn || !btn.__spdInit) && ++initTries < 40) setTimeout(initTick, 250);
  })();

  /* clear studio mode whenever the PDP picker is dismissed without a pick */
  document.addEventListener('click', function (e) {
    if (!window.__studioPickActive || !e.target) return;
    var closest = e.target.closest && e.target.closest('.customTabelPopup__overlay-3 .customTabelPopup__close');
    var backdrop = e.target.classList && e.target.classList.contains('customTabelPopup__overlay-3');
    if (closest || backdrop) window.__studioPickActive = false;
  });
  /* …and whenever the alv2 modal closes — DEFERRED. On a pick, the shell
     closes synchronously while md-picker:use-designs is still bubbling toward
     the document handler below; clearing here inline would drop the flag
     before that handler reads it and the pick would be discarded. One tick
     later the pick handler has run (and cleared the flag itself); on a plain
     dismiss the timeout is the only clearer. */
  document.addEventListener('alv2:modal-closed', function () {
    setTimeout(function () { window.__studioPickActive = false; }, 0);
  });

  /* ---- selection → canvas ---- */
  document.addEventListener('md-picker:use-designs', function (e) {
    var so = studioOverlay();
    var fromStudioModal = isOpen(so);
    var fromPdpModal = !!window.__studioPickActive;
    if (!fromStudioModal && !fromPdpModal) return; /* normal PDP pick — the upload bridges own it */
    var items = (e.detail && e.detail.items) || [];
    if (!items.length) return;
    if (fromStudioModal) so.style.display = 'none';
    if (fromPdpModal) {
      window.__studioPickActive = false;
      var po = pdpOverlay();
      if (po) po.style.display = 'none';
    }
    insertAll(items);
  });

  /* Non-blocking notice — native alert() freezes the page (and blocks
     automation/CDP) until dismissed; a toast can't. */
  function toast(msg) {
    var t = document.createElement('div');
    t.textContent = msg;
    t.style.cssText = 'position:fixed;left:50%;bottom:32px;transform:translateX(-50%);background:#0f172a;color:#fff;font:600 14px/1.4 "DM Sans",system-ui,sans-serif;padding:12px 20px;border-radius:10px;box-shadow:0 6px 24px rgba(15,23,42,0.35);z-index:100001;max-width:min(480px,90vw);text-align:center;';
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 4500);
  }

  function waitForCanvas() {
    if (window.fabricCanvas) return Promise.resolve();
    try { if (typeof window.__ensureV0Js === 'function') window.__ensureV0Js(function () {}); } catch (_) {}
    return new Promise(function (resolve, reject) {
      var n = 0;
      (function tick() {
        if (window.fabricCanvas) return resolve();
        if (++n > 150) return reject(new Error('fabricCanvas not ready'));
        setTimeout(tick, 100);
      })();
    });
  }

  /* basename, decoded and with S3 plus-encoded spaces normalized, so
     "Ready+to+Press+Designs/%231266+Soccer.png" and the metafield's
     "Ready to Press Designs/#1266 Soccer.png" compare equal. */
  function normBase(u) {
    var b = String(u).split('/').pop().split('?')[0];
    try { b = decodeURIComponent(b); } catch (_) {}
    return b.replace(/\+/g, ' ').trim();
  }

  /* Last-resort for Ready-To-Press files: every RTP design is also a Shopify
     product whose featured image (CORS *) is the same art. Resolve through the
     same-origin rtp-json search view by matching the file basename, then fetch
     the CDN master (width param stripped). */
  function rtpImgLookup(fileUrl) {
    var name = normBase(fileUrl);
    if (!name) return Promise.reject(new Error('no basename'));
    var title = name.replace(/\.[a-z0-9]+$/i, '').replace(/^#?\d+\s*/, '').replace(/[_-]+/g, ' ').trim();
    var q = 'product_type:"Ready To Press" ' + title;
    return fetch('/search?view=rtp-json&type=product&q=' + encodeURIComponent(q))
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var items = (j && j.items) || [];
        var hit = items.find(function (x) { return x && x.file && normBase(x.file) === name; });
        if (!hit || !hit.img) throw new Error('rtp lookup miss');
        return String(hit.img).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
      });
  }

  /* CORS-fetchable source candidates, tried in order. */
  function fetchCandidates(it) {
    var url = String(it.file || '');
    var bare = url.split('?')[0];
    var out = [];
    var isVector = CONVERT_EXT.test(bare);
    var imgix = '';
    if (url.indexOf(S3_UPLOADS) > -1) imgix = url.split(S3_UPLOADS).join(IMGIX_UPLOADS);
    else if (url.indexOf('imgix.net') > -1) imgix = url;
    if (imgix) {
      out.push(isVector ? imgix + (imgix.indexOf('?') > -1 ? '&' : '?') + 'fm=png&w=2000' : imgix);
    }
    /* RTP originals: rtp-mirror copy first (uploads bucket, CORS ✓), direct
       S3 second (takes over if the ninja-imgix bucket ever gets CORS). */
    if (url.indexOf('s3.amazonaws.com/ninja-imgix/') > -1) {
      out.push('https://' + IMGIX_UPLOADS + '/rtp-mirror/' + encodeURIComponent(normBase(url)));
    }
    if (url && !isVector && out.indexOf(url) === -1) out.push(url);
    if (it.img) {
      out.push(String(it.img).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''));
    }
    return out;
  }

  function insertOne(it, idx) {
    var cands = fetchCandidates(it);
    if (!cands.length) return Promise.reject(new Error('no fetchable url'));
    var p = Promise.reject();
    cands.forEach(function (u) {
      p = p.catch(function () {
        return fetch(u).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status + ' ' + u);
          return r.blob();
        });
      });
    });
    if (String(it.file || '').indexOf('s3.amazonaws.com/ninja-imgix/') > -1) {
      p = p.catch(function () {
        return rtpImgLookup(it.file).then(function (imgUrl) {
          return fetch(imgUrl).then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status + ' ' + imgUrl);
            return r.blob();
          });
        });
      });
    }
    return p.then(function (blob) {
      /* JPEG means we fell back to the Shopify product image (a mockup on
         white) instead of the transparent RTP original — only happens for
         library files missing from the rtp-mirror. Log it so gaps surface. */
      if (blob.type === 'image/jpeg' && String(it.file || '').indexOf('s3.amazonaws.com/ninja-imgix/') > -1) {
        console.warn('[studio-prev-designs] rtp-mirror miss, used product image for', it.file);
      }
      var type = (blob.type && blob.type.indexOf('image/') === 0) ? blob.type : 'image/png';
      var extMap = { 'image/png': 'png', 'image/jpeg': 'jpg', 'image/webp': 'webp', 'image/gif': 'gif' };
      var ext = extMap[type] || 'png';
      var raw = String(it.fileName || String(it.file || '').split('?')[0].split('/').pop() || 'design');
      var base = raw.split('.')[0].toLowerCase().replace(/[^a-z0-9]/gi, '-').replace(/-+/g, '-').replace(/^-|-$/g, '') || 'design';
      var fname = base + '____image_' + Date.now() + '_' + Math.floor(Math.random() * 1000) + '.' + ext;
      if (typeof window.getPresignedUploadUrl !== 'function') throw new Error('getPresignedUploadUrl unavailable');
      return window.getPresignedUploadUrl(fname, type).then(function (presign) {
        if (!presign || !presign.url || !presign.sourceUrl) throw new Error('presign failed');
        return fetch(presign.url, { method: 'PUT', headers: { 'Content-Type': type }, body: blob })
          .then(function (res) {
            if (!res.ok) throw new Error('PUT ' + res.status);
            return presign.sourceUrl;
          });
      });
    }).then(function (uploadedUrl) {
      return new Promise(function (resolve, reject) {
        window.fabric.Image.fromURL(uploadedUrl, function (img) {
          if (!img || !img.width) { reject(new Error('image load failed')); return; }
          var maxSize = 300;
          var scale = Math.min(maxSize / img.width, maxSize / img.height, 1);
          img.set({ scaleX: scale, scaleY: scale, selectable: true, hasControls: true, lockUniScaling: false });
          img._originalUrl = uploadedUrl;
          img._bgRemoved = false;
          var canvas = window.fabricCanvas;
          if (typeof window.addObjectToCanvas === 'function') window.addObjectToCanvas(img, canvas);
          else { canvas.add(img); canvas.setActiveObject(img); canvas.requestRenderAll(); }
          /* cascade AFTER addObjectToCanvas (which centers) so the pick never
             stacks on ANY existing image — batch mates or images already on the
             canvas (Justin 7-10). Falls back to the old per-batch offset if the
             shared helper (v0-script.js) isn't there (stale cache). */
          if (typeof window.ntCascadeImage === 'function') {
            window.ntCascadeImage(img, canvas);
          } else if (idx > 0) {
            img.set({ left: (img.left || 0) + idx * 30, top: (img.top || 0) + idx * 30 });
            img.setCoords();
            canvas.requestRenderAll();
          }
          resolve();
        }, { crossOrigin: 'anonymous' });
      });
    });
  }

  function insertAll(items) {
    var btn = document.getElementById('prev-designs-btn');
    var origHtml = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = '<span class="tb-action-label">Loading…</span><span class="tb-action-label-short">Loading…</span>'; }
    /* canvas-centered blue loader too (Justin 7-10) — same spinner the studio's
       BG-remove toggle uses (showCanvasSpinner in v0-script.js), guarded in case
       this picker ever renders without the studio core. */
    if (typeof window.showCanvasSpinner === 'function') window.showCanvasSpinner();
    waitForCanvas().then(function () {
      var chain = Promise.resolve();
      var failed = 0;
      items.forEach(function (it, i) {
        chain = chain.then(function () {
          return insertOne(it, i).catch(function (err) {
            failed++;
            console.error('[studio-prev-designs] insert failed:', it && it.file, err);
          });
        });
      });
      return chain.then(function () {
        try { if (typeof window.updateLayers === 'function') window.updateLayers(); } catch (_) {}
        try { if (typeof window.saveState === 'function') window.saveState(); } catch (_) {}
        if (failed) {
          toast(failed === items.length
            ? 'Sorry — that design could not be loaded. Please try again.'
            : 'Some designs could not be loaded.');
        }
      });
    }).catch(function (err) {
      console.error('[studio-prev-designs]', err);
      toast('The design studio is still loading — please try again in a moment.');
    }).then(function () {
      if (typeof window.hideCanvasSpinner === 'function') window.hideCanvasSpinner();
      if (btn) { btn.disabled = false; btn.innerHTML = origHtml; }
    });
  }
})();
